<div #contentContainerRef>
  <ng-content></ng-content>
</div>

<dx-popover
  #popoverTmp
  [target]="target ?? contentContainerRef"
  [container]="container"
  showEvent="click"
  [hideEvent]="''"
  [wrapperAttr]="{ class: 'color-sketch-popover__picker-popup ag-click-outside--exclusion' }"
  [width]="'auto'"
  [height]="370"
  [shading]="true"
  (onShowing)="handleShowing($event)"
  [hideOnOutsideClick]="handleOutsidePopoverClick"
  [toolbarItems]="[
    { location: 'after', toolbar: 'bottom', template: 'cancelButtonTmp' },
    { location: 'after', toolbar: 'bottom', template: 'applyButtonTmp' },
  ]"
>
  <div *dxTemplate="let data of 'cancelButtonTmp'">
    <dx-button text="Cancel" (onClick)="cancelColorChanges($event, popoverTmp)" [width]="80"></dx-button>
  </div>

  <div *dxTemplate="let data of 'applyButtonTmp'">
    <dx-button
      text="Apply"
      [type]="'default'"
      (onClick)="applyColorChanges($event, popoverTmp)"
      [width]="80"
    ></dx-button>
  </div>

  <div
    *dxTemplate="let popoverData of 'content'"
    class="ag-click-outside--exclusion"
    (click)="$event.stopPropagation()"
  >
    <div class="color-sketch-popover__container" #hexGuardRoot>
      <ng-container *ngFor="let _ of [colorSketchRenderTick]">
        <color-sketch
          [width]="260"
          [color]="selectedColor | colorSketchPopoverCssVarsParser: contentContainerRef"
          (onChange)="handleChange($event)"
          [presetColors]="[]"
        ></color-sketch>
      </ng-container>

      <dx-tooltip
        [target]="hexInputTarget"
        [visible]="showHexValidationMessage && !!hexInputTarget"
        [showEvent]="''"
        [hideEvent]="''"
        [position]="{ my: 'left top', at: 'left bottom', offset: '0 6' }"
        [wrapperAttr]="{
        class:
          'color-sketch-popover__invalid-message ag-click-outside--exclusion',
      }"
        [hideOnOutsideClick]="false"
      >
        <div *dxTemplate="let data = data of 'content'">Hex value must contain 6 symbols.</div>
      </dx-tooltip>

      <dx-scroll-view [useNative]="false" [showScrollbar]="'always'" [height]="'100%'">
        <div class="color-sketch-popover__preset-colors">
          @for (color of presetColors; track $index) {
            <dx-button
              #colorButton
              class="color-sketch-popover__preset-color color-sketch-input__square-container"
              icon="square"
              [class.color-sketch-popover__preset-color--active]="selectedColor === color?.value"
              [class.color-sketch-input__square-container--transparent]="color?.value === 'transparent'"
              [style.--preset-color]="color?.value"
              [style.--value-color]="color?.value"
              [text]="color?.description"
              (onClick)="applyColor(color?.value)"
              [activeStateEnabled]="false"
              [focusStateEnabled]="false"
              template="buttonContent"
            >
              <div *dxTemplate="let data = data of 'buttonContent'">
                <div class="color-sketch-popover__button-container">
                  <i class="dx-icon dx-icon-square"></i>
                  <span>
                    {{ color?.description }}
                  </span>

                  <i #buttonTooltipTarget class="dx-icon dx-icon-info color-sketch-popover__info-icon">
                    <dx-tooltip [target]="buttonTooltipTarget" showEvent="mouseenter" hideEvent="mouseleave">
                      <div *dxTemplate="let data = data of 'content'">{{ color?.hint ?? color?.description }}</div>
                    </dx-tooltip>
                  </i>
                </div>
              </div>
            </dx-button>
          }
        </div>
      </dx-scroll-view>
    </div>
  </div>
</dx-popover>
